import React from "react";
import HelpAll from "../component/sections/help/All";
import StepByStepCreateCampaignBanner from "../component/sections/help/StepByStepCreateCampaignBanner";

const routes = [
  {
    path: "/help",
    render: () => <HelpAll />,
    exact: true,
  },
  {
    path: "/help/step-by-step-create-campaign-banner",
    render: () => <StepByStepCreateCampaignBanner />,
    exact: true,
  },
];

export default routes;
